import Quill, { Delta } from 'quill';
import { writable } from 'svelte/store';
export const textElementsStore = writable([]);
export const allTextElementsStore = writable([]);
export const textAIElementsStore = writable([]);
export class TextLoader {
    node;
    constructor(node) {
        this.node = node;
        this.identifyTextElements();
        this.textElements.forEach(el => {
            if (el) {
                const dynamicEl = el.querySelector('.dynamic');
                if (dynamicEl) {
                    let quill = new Quill(dynamicEl, { modules: { clipboard: {
                                matchers: [
                                    [Node.ELEMENT_NODE, function (node, delta) {
                                            return new Delta().insert(node?.textContent + '\n');
                                        }
                                    ]
                                ]
                            } } });
                    quill.on('text-change', () => {
                        console.log('text changed', quill.getText());
                        this.identifyTextElements();
                    });
                    dynamicEl?.addEventListener('click', () => {
                        quill.focus();
                    });
                }
            }
        });
    }
    allTextElements = [];
    textElements = [];
    identifyTextElements() {
        const notIncludedElements = ['caption'];
        // Get text elements that dont have a data-amelement attribute
        this.allTextElements = Array.from(this.node.querySelectorAll('.userTextClass'));
        this.textElements = this.allTextElements.filter(element => element && !notIncludedElements.includes(element.dataset?.amelement));
        const textAIElements = this.allTextElements.filter(element => element && element.dataset?.amelement === 'quote');
        allTextElementsStore.set([...this.allTextElements]);
        textElementsStore.set([...this.textElements]);
        textAIElementsStore.set([...textAIElements]);
    }
}
